import React from 'react'
import phoneRingImg from '@prague-digi/ui-styles/src/images/nwp-icon/phone-ring.svg'
import { BLine, BText } from '@prague-digi/ui-components'

import { intl, IntlInterface } from '../../hoc'
import { SUPPORT_PHONE } from '../../constants/commonConstants'
import styles from './styles.scss'

import messages from '../../i18n'

type Props = IntlInterface

export const CallUs: React.FC<Props> = ({ translateHTML }: Props) => (
  <>
    <BLine theme="mb-4 mt-4" />
    <BText center type="info" theme="font-weight-bold">
      <img alt="phone" className={styles.callUs} src={phoneRingImg} />
      {translateHTML(messages.components.callUs, { phone: SUPPORT_PHONE })}
    </BText>
  </>
)

export default intl(CallUs)
